import React, { useCallback } from "react";
import { Button, Icon } from "rsuite";
import styled from "styled-components";

import { withTranslation } from "hoc/WithTranslation";
import m from "definedMessages";


const PaymentsSectionHeader = ({ title = null, show = false, callback = null, formatMessage }) => {
    const handleClick = useCallback(() => {
        if (callback) callback();
    }, [callback]);

    return (
        <FlexBlock>
            {title && <SectionTitle>{title}</SectionTitle>}

            <Button size="sm" appearance="link" onClick={handleClick}>
                {show ? (
                    <>
                        <Icon icon="angle-up" />&nbsp;
                        {formatMessage(m.hide)}
                    </>
                ) : (
                    <>
                        <Icon icon="angle-down" />&nbsp;
                        {formatMessage(m.show)}
                    </>
                )}
            </Button>
        </FlexBlock>
    );
};

export default withTranslation(PaymentsSectionHeader);

const FlexBlock = styled.div`
    display: flex;
    align-items: center;
`;

const SectionTitle = styled.h2`
    flex-grow: 1;
    font-size: 1.1rem;
    font-weight: 500;
    line-height: 1.2em;
    margin: 0;
    width: auto;
    color: var(--color-brand1);

    @media (min-width: 768px) {
        max-width: 200px;
    }
`;
